import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes, FaLeaf } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => scrollToSection('hero')}>
          <FaLeaf className="logo-icon" />
          <span className="logo-text">
            Gestión <span className="logo-highlight">Club</span>
          </span>
        </div>

        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <a href="#inicio" onClick={() => scrollToSection('hero')}>Inicio</a>
          <a href="#servicios" onClick={() => scrollToSection('servicios')}>Funcionalidades</a>
          <a href="#beneficios" onClick={() => scrollToSection('beneficios')}>Beneficios</a>
          <a href="#contacto" onClick={() => scrollToSection('contacto')}>Contacto</a>
          <button className="btn btn-primary" onClick={() => scrollToSection('contacto')}>
            Solicitar Demo
          </button>
        </div>

        <div className="navbar-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

